/**
 * Leaflet地図用のマーカーアイコン定義
 *
 * 使用箇所:
 * - PlaceSearchModal.tsx
 * - SpotCreateByPlaceSearch.tsx
 */
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

// デフォルトマーカー（青）
export const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});

// ハイライトマーカー（オレンジ・大きめ）
export const HighlightIcon = L.icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png",
  shadowUrl: iconShadow,
  iconSize: [35, 57],
  iconAnchor: [17, 57],
  popupAnchor: [1, -48]
});

// 重複スポット用マーカー（グレー）
// TODO: 外部CDN依存を削減するため、マーカー画像をローカルにホストすることを検討
// 現在、GitHub CDN (raw.githubusercontent.com) に依存しており、
// リポジトリ削除やGitHub障害時に画像が読み込めなくなる可能性がある
// 推奨対応: public/images/leaflet-markers/ にダウンロードして配置
export const DuplicateIcon = L.icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-grey.png",
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34]
});

// デフォルトアイコンのグローバル設定
L.Marker.prototype.options.icon = DefaultIcon;
